import { useQuery } from '@tanstack/react-query';

export type DataExportConfigOption = {
  id: string;
  displayName: string;
  isDefault: boolean;
};

export function useDataExportConfigOptions() {
  const { data, isLoading } = useQuery<DataExportConfigOption[]>({
    queryKey: ['data-export-config-options'],
  });

  return {
    configs: data ?? [],
    isLoading,
  };
}
